import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Box } from "../components/styled/Elements";
import AdminHeader from "../components/admin/AdminHeader/AdminHeader";
import AdminSidebar from "../components/admin/AdminSidebar/AdminSidebar";
import { useDispatch } from "react-redux";
import ProductsApi from "../services/api/productsApi";
import {
  setCategoriesList,
  setProductsList,
} from "../store/slices/helperSlice";
import useAuth from "../context/authContext";
import AuthApi from "../services/api/authApi";
import CategoriesApi from "../services/api/categoriesApi";

const AdminLayout = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const dispatch = useDispatch();
  const { isAuthenticated } = useAuth();
  const [sidebarStatus, setSidebarStatus] = useState(false);

  const pollForUpdates = (interval = 60000) => {
    let pollingInterval;

    const startPolling = () => {
      if (navigator.onLine) {
        pollingInterval = setInterval(async () => {}, interval);
      }
    };

    const stopPolling = () => {
      if (pollingInterval) {
        clearInterval(pollingInterval);
      }
    };

    // Listen for online/offline events
    const handleOnline = () => {
      startPolling();
    };

    const handleOffline = () => {
      stopPolling();
    };

    // Attach event listeners
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Start polling
    startPolling();

    // Cleanup function
    return () => {
      stopPolling();
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  };

  useEffect(() => {
    let pollingInterval;
    const startPolling = () => {
      if (navigator.onLine) {
        pollingInterval = setInterval(async () => {}, 60000);
      }
    };

    const stopPolling = () => {
      if (pollingInterval) {
        clearInterval(pollingInterval);
      }
    };

    // Listen for online/offline events
    const handleOnline = () => {
      startPolling();
    };

    const handleOffline = () => {
      stopPolling();
    };

    // if (userType === 4 || userType === 3) {
    //   // Attach event listeners
    //   window.addEventListener("online", handleOnline);
    //   window.addEventListener("offline", handleOffline);

    //   // Start polling
    //   startPolling();
    // }

    // Cleanup function
    return () => {
      stopPolling();
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);
  const getBankInfo = async () => {
    try {
      const { data, code } = await AuthApi.getBankInfo();
      if (code === 200) {
        localStorage.setItem("bank_info", JSON.stringify(data));
      }
    } catch (error) {}
  };

  const fetchAllProducts = async () => {
    const { data, code } = await ProductsApi.productsListWithoutPg();
    if (code === 200 && data) {
      const formattedData = data?.map((prod) => ({
        ...prod,
        name: language === "en" ? prod?.name_en : prod?.name_ar,
      }));
      dispatch(setProductsList(formattedData));
    }
  };
  const fetchAllCategories = async () => {
    const { data, code } = await CategoriesApi.categoriesList(1, "", false);
    if (code === 200 && data) {
      const formattedData = data?.map((prod) => ({
        ...prod,
        name: language === "en" ? prod?.name_en : prod?.name_ar,
      }));
      dispatch(setCategoriesList(formattedData));
    }
  };

  useEffect(() => {
    getBankInfo();
    if (isAuthenticated) {
      fetchAllCategories();
      fetchAllProducts();
    }
  }, [language]);

  useEffect(() => {
    const categoryHandler = () => fetchAllCategories()
    const productHandler = () => fetchAllProducts()
    window.addEventListener("productCategoryUpdated", categoryHandler)
    window.addEventListener("productUpdated", productHandler)

    return () => {
      window.removeEventListener("productCategoryUpdated", categoryHandler)
      window.removeEventListener("productUpdated", productHandler)
    }
  }, [])

  return (
    <LayoutWrapper className="d-flex center-main">
      <Box>
        <AdminSidebar
          sidebarStatus={sidebarStatus}
          setSidebarStatus={setSidebarStatus}
        />
      </Box>
      <Box className="flex-1 w-100">
        <AdminHeader
          sidebarStatus={sidebarStatus}
          setSidebarStatus={setSidebarStatus}
        />
        <Box className={"flex-1 custom-scroll pb-4 content-main"}>
          <Outlet />
        </Box>
      </Box>
    </LayoutWrapper>
  );
};

export default AdminLayout;

const LayoutWrapper = styled.div`
  background-color: var(--bgSecondary);
`;
